import { ScalerFilter } from '../utils/numberFilter';
import { TextFilter } from '../utils/textFilter';

export const sortTypes = Object.freeze({
  text: 'text',
  numeric: 'numeric',
});

export const defaultFilterTypes = Object.freeze({
  [sortTypes.text]: TextFilter.EQUALS,
  [sortTypes.numeric]: ScalerFilter.EQUALS,
});

export const sortOrders = Object.freeze({
  DESCENDING: 'DESCENDING',
  ASCENDING: 'ASCENDING',
});

export const FilterSymbols = Object.freeze({
  [ScalerFilter.EQUALS]: '=',
  [ScalerFilter.NOT_EQUAL]: '!=',
  [ScalerFilter.LESS_THAN]: '<',
  [ScalerFilter.LESS_THAN_OR_EQUAL]: '?',
  [ScalerFilter.GREATER_THAN]: '>',
  [ScalerFilter.GREATER_THAN_OR_EQUAL]: '?',
});

export const nonPointKeys = Object.freeze({
  system: 'system',
  number: 'number',
  desc: 'desc',
  time: 'time',
});

export const filtersConstant = {
  ageInDays: 'ageInDays',
  haveRecommendations: 'haveRecommendations',
  assetCategory: 'assetCategory',
  benefits: 'benefits',
  condition: 'condition',
  resolutionType: 'resolutionType',
  urgency: 'urgency',
  workInProgress: 'workInProgress',
  activities: 'activities',
  workOrder: 'workOrder',
  repairType: 'repairType',
  component: 'component',
  fieldTech: 'fieldTech',
  objective: 'objective',
  subObjective: 'subObjective',
};

export const COMBI_CODE_CHIP_SORT_ORDER = Object.freeze({
  insightStatus: 0,
  resolutionType: 1,
  quickTags: 2,
});

export const comboCodeListFilterObj = {
  insightCategory: 'condition',
  PGMOBJ: 'benefits',
};
export const comboCodefilterTagsNames = [
  'insightFamily',
  'insightSubFamily',
  'PGMSOB',
];

export const sortUrgencyObj = {
  urgencyKey: 'pai.urgency.id',
  urgencyId: 'urgent',
};
export const urgencyNone = 'None';

export const ageKeyIdenitifer = {
  createDate: 'createDate',
  lastSubmission: 'lastSubmission',
  ageCreateOption: 'ageCreateOption',
  ageCreateDaysValue: 'ageCreateDaysValue',
  ageLastSubOption: 'ageLastSubOption',
  ageLastSubDaysValue: 'ageLastSubDaysValue',
};

export const ageKeyMapTraslation = {
  createDate: 'Create_Date',
  lastSubmission: 'Last_condition_date',
};

export const assetSortType = {
  desc: 'High_to_low',
  asc: 'Low_to_high',
};
